import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import _cloneDeep from 'lodash/cloneDeep';
import MenuItem from '@mui/material/MenuItem';
import { comparisonParams, filterParams } from '../../../utils/segments';
import { addQueryParams } from '../../../utils/browser';
import ReduxStore from 'src/types/store/reduxStore';
import _pick from 'lodash/pick';
import { AdManagerAdCampaignEntity } from 'sl-api-connector';

const mapStateToProps = (state: ReduxStore) =>
  _pick(state, ['app', 'adEntities', 'adCampaigns', 'categories', 'entityService', 'retailer', 'mainTimePeriod']);

type Props = ReturnType<typeof mapStateToProps> &
  RouteComponentProps & {
    searchText: string;
    togglePanel?: () => {};
  };

class Campaigns extends React.Component<Props> {
  public state: {
    campaigns: AdManagerAdCampaignEntity[];
  } = { campaigns: [] };

  componentWillMount() {
    const { adCampaigns } = this.props;
    const campaigns = _cloneDeep(adCampaigns);

    this.setState({ campaigns });
  }

  componentWillReceiveProps(nextProps) {
    const { searchText, campaigns } = nextProps;

    const filteredCampaigns = campaigns.filter(
      (val) => val.displayName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    this.setState({
      campaigns: filteredCampaigns
    });
  }

  handleTouchTap = (selection) => {
    const { togglePanel, location, retailer, mainTimePeriod } = this.props;
    const entity = {
      id: selection.id,
      type: 'adCampaign'
    };

    const existingParams = addQueryParams(location, retailer, mainTimePeriod, [...filterParams, ...comparisonParams]);

    togglePanel();
    this.props.history.push(`?ctype=${entity.type}&cid=${entity.id}&${existingParams}`);
  };

  showNoCampaigns() {
    const { campaigns } = this.state;

    if (campaigns.length > 0) {
      return null;
    }

    return <div style={{ padding: '10px' }}>No campaigns found.</div>;
  }

  render() {
    const { campaigns } = this.state;
    return (
      <div style={{ padding: '10px' }}>
        {campaigns.map((val) => (
          <MenuItem key={val.campaignId} style={{ fontSize: '14px' }} onClick={() => this.handleTouchTap(val)}>
            {val.displayName}
          </MenuItem>
        ))}
        {this.showNoCampaigns()}
      </div>
    );
  }
}

export default withRouter(connect((state) => state)(Campaigns));
